import { TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SchedulingComponent } from '../../scheduling.component';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { ScheduleStateService } from 'src/services/scheduleStateService.service';
import { TranslateService } from '@ngx-translate/core';
import { Appointment } from '../../../../models/appointment';
import { HelperService } from 'src/services/helperService';
import moment from 'moment';

@Component({
    selector: 'app-cancel-appointment',
    templateUrl: './cancel-appointment.dialog.html',
    styleUrls: ['./cancel-appointment.dialog.sass'],
    providers: [TitleCasePipe],
    standalone: false
})
export class CancelAppointmentDialog {
  appointmentSchedule = '';
  showScheduler: boolean = true;
  dropdownData: boolean = false;
  schedule;
  isDeleting = true;
  deleteAppointmentPreventiveMessage: string = '';
  deleteAppointmentPreventiveMessageTwo: string = '';
  deleteAppointmentPreventiveMessageThree: string = '';
  typeOfService: string = '';

  constructor(
    public dialogRef: MatDialogRef<SchedulingComponent>,
    @Inject(MAT_DIALOG_DATA) public appointment: any,
    public titleCasePipe: TitleCasePipe,
    public SchedulerService: APISchedulerService,
    public scheduleStateService: ScheduleStateService,
    private translate: TranslateService,
    public helperService: HelperService
  ) {
     

    this.appointmentSchedule = this.titleCasePipe.transform(
      `${ new Date(appointment.EventStart).toLocaleDateString(this.helperService.user.language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
         ${moment(new Date(appointment.EventStart)).format('h:mm a')} - ${moment(new Date(appointment.EventEnd)).format('h:mm A')} `); 
         
 

    this.SchedulerService.get(this.appointment.id).subscribe((schedule) => {
       this.isDeleting = false;
      this.schedule = schedule;
    });
    this.deleteAppointmentPreventiveMessage = this.translate.instant(
      'AreYouSureToCancelFirstPart'
    );
    this.deleteAppointmentPreventiveMessageTwo = this.translate.instant(
      'AreYouSureToCancelSecondPart'
    );
    this.deleteAppointmentPreventiveMessageThree =
      this.translate.instant('Definitely');
    this.typeOfService = this.translate.instant(
      appointment.typeOfService
    );
    
    this.appointmentSchedule = this.appointmentSchedule;
  }

  DeleteSchedule() {
    this.dropdownData = true;
    const typeOfService = this.appointment.typeOfService;
    this.schedule.sendToHabeasData = this.schedule.sendToHabeasData ? this.schedule.sendToHabeasData :false
    this.schedule.sendToKeyloop =  this.schedule.sendToKeyloop ?  this.schedule.sendToKeyloop : false
    this.schedule.sendToSap =  this.schedule.sendToSap ?  this.schedule.sendToSap : false
    delete this.schedule.dataProcessing;
    if(!this.schedule.representativeId){delete this.schedule.representativeId;}
    this.schedule.schedulerStatusId = 5;
   
    this.isDeleting = true;
    this.SchedulerService.put(this.schedule).subscribe({
      next: (r) => {
      
        if (r.schedulerStatusId === this.schedule.schedulerStatusId) {
          const cancelSuccessMsg = this.translate.instant('CancelSuccessMsg', {
            typeOfService: this.translate.instant(typeOfService),
          });
          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =cancelSuccessMsg 
          this.helperService.cancelacion_citas = true
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)
        } else {
          const cancelFailed = this.translate.instant('cancelFailedMsg');
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =cancelFailed 
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)
        }
      },
      complete: () => {
        this.isDeleting = false;
        this.dialogRef.close();
        this.scheduleStateService.changeScheduleState(true);
      },
        error: (error) => {

          if(error.status === 401){
            this.helperService.logoutToken()
          }
          else {
          const translateTextError = this.translate.instant(
            'CancelFailedMsg'
          );
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =translateTextError 
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)}
        }
      
  
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
